export default function validateMandatoryExpressions(question, data) {
  var exp = "";
  const occurrences = getPatternOccurrencesWithIndexes(question.mandatory);

  for (const occurrence of occurrences) {
    if (occurrence.pattern[0] != "{") {
      exp = exp + occurrence.pattern;
    } else if (occurrence.pattern[1] == "T") {
      exp = exp + "true";
    } else if (occurrence.pattern[1] == "F") {
      exp = exp + "false";
    } else {
      if (occurrence.pattern.slice(3, -2) == "ANYTRUE") {
        const entries = Object.entries(data);

        var result = "false";
        for (const [key, value] of entries) {
          if (value == "1") {
            result = "true";
            break;
          }
        }
        exp = exp + result;
      } else {
        var parsed_number = data[occurrence.pattern.slice(3, -2)];
        if (parsed_number) {
          exp = exp + "true";
        } else {
          exp = exp + "false";
        }
      }
    }
  }

  var is_mandatory = eval(exp);
  if (is_mandatory) {
    var value = data[question.id];
    var value =
      question.type == "B"
        ? data[question.id] == "0"
          ? 0
          : data[question.id]
        : data[question.id];
    if (value) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}

function getPatternOccurrencesWithIndexes(input) {
  const pattern = /\{[^}]+\}/g;
  const occurrences = [];
  let match;
  let lastIndex = 0;

  while ((match = pattern.exec(input)) !== null) {
    if (match.index > lastIndex) {
      const operator = input.slice(lastIndex, match.index).trim();
      if (operator) {
        occurrences.push({
          pattern: operator,
          startIndex: lastIndex,
          endIndex: match.index - 1,
        });
      }
    }

    occurrences.push({
      pattern: match[0],
      startIndex: match.index,
      endIndex: match.index + match[0].length - 1,
    });

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < input?.length) {
    const operator = input.slice(lastIndex).trim();
    if (operator) {
      occurrences.push({
        pattern: operator,
        startIndex: lastIndex,
        endIndex: input.length - 1,
      });
    }
  }

  return occurrences;
}
